// Array representing age ranges
export const ageRanges = [
  { label: "0 - 12", value: "0", postfix: "M" },
  { label: "1", value: "1", postfix: "Year" },
  { label: "2", value: "2", postfix: "Years" },
  { label: "3", value: "3", postfix: "Years" },
  { label: "4", value: "4", postfix: "Years" },
  { label: "5", value: "5", postfix: "Years" },
  { label: "6", value: "6", postfix: "Years" },
  { label: "7", value: "7", postfix: "Years" },
  { label: "8", value: "8", postfix: "Years" },
  { label: "9", value: "9", postfix: "Years" },
  { label: "10", value: "10", postfix: "Years" },
  { label: "11", value: "11", postfix: "Years" },
  { label: "12", value: "12", postfix: "Years" },
  { label: "13", value: "13", postfix: "Years" },
  { label: "14", value: "14", postfix: "Years" },
  { label: "15", value: "15", postfix: "Years" },
  { label: "16", value: "16", postfix: "Years" },
  { label: "17", value: "17", postfix: "Years" },
  { label: "18", value: "18", postfix: "Years" },
];

const shouldShowBookshop = process.env.SHOW_BOOKSHOP === "true";

export const RETAILERS = {
  Amazon: "Amazon",
  "Apple Books": "Apple Books",
  "Barnes & Noble": "Barnes & Noble",
  ...(shouldShowBookshop ? { Bookshop: "Bookshop.org" } : {}),
  Google: "Google",
  Kobo: "Kobo",
  "Books A Million": "Books A Million",
};

export const normalizeRetailer = (retailer) => {
  const lowerRetailer = retailer === "Bookshop.org" ? "bookshop" : retailer?.toLowerCase();

  const retailerMap = {
    amazon: "Amazon",
    "apple books": "Apple Books",
    apple: "Apple Books",
    "barnes & noble": "Barnes & Noble",
    bn: "Barnes & Noble",
    google: "Google",
    kobo: "Kobo",
    "books a million": "Books A Million",
    bam: "Books A Million",
    bookshop: "Bookshop.org",
  };

  return retailerMap[lowerRetailer];
};
